import React from 'react';
import { FONTS } from '../../styles/tokens';

interface NotificationBellProps {
  unread: number;
  open: boolean;
  onToggle: () => void;
  textPrimary: string;
  textSecondary: string;
  border: string;
}

/**
 * Header bell icon with unread-count badge. Click toggles the drawer
 * visibility — parent owns the drawer rendering.
 */
export function NotificationBell(props: NotificationBellProps): React.JSX.Element {
  return (
    <button
      type="button"
      onClick={props.onToggle}
      aria-label={`${props.unread} unread notifications`}
      style={{
        position: 'relative',
        width: '36px', height: '36px',
        borderRadius: '8px',
        border: `1px solid ${props.border}`,
        background: props.open ? '#01A9ED' : 'transparent',
        color: props.open ? '#FFF' : props.textPrimary,
        cursor: 'pointer',
        fontFamily: FONTS.heading, fontSize: '14px',
      }}
    >
      <BellGlyph />
      {props.unread > 0 && <Badge count={props.unread} />}
    </button>
  );
}

/** Simple inline SVG bell. */
function BellGlyph(): React.JSX.Element {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ display: 'block', margin: 'auto' }}>
      <path d="M8 2v1M3 7a5 5 0 0110 0v4l1 2H2l1-2V7zM6 13a2 2 0 004 0" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Numeric unread badge. Clamps at 9+. */
function Badge({ count }: { count: number }): React.JSX.Element {
  const display = count > 9 ? '9+' : String(count);
  return (
    <span
      style={{
        position: 'absolute', top: '-4px', right: '-4px',
        minWidth: '18px', height: '18px',
        borderRadius: '999px',
        background: '#EF4444', color: '#FFF',
        fontFamily: FONTS.heading, fontSize: '10px',
        display: 'grid', placeItems: 'center', padding: '0 5px',
      }}
    >
      {display}
    </span>
  );
}
